import React from "react";

const Modal = ({ isOpen, onClose, title, children }) => {
    if (!isOpen) return null;

    return (
        <div style={styles.overlay}>
            <div style={styles.modal}>
                {/* Fixed Header */}
                <div style={styles.header}>
                    <h2 style={styles.modalTitle}>{title}</h2>
                    <button onClick={onClose} style={styles.closeBtn}>×</button>
                </div>

                {/* Scrollable Content */}
                <div style={styles.content}>
                    {children}
                </div>
            </div>
        </div>
    );
};

const styles = {
    overlay: {
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0,0,0,0.5)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1000
    },
    modal: {
        background: "#fff",
        borderRadius: "8px",
        width: "500px",
        maxWidth: "90%",
        maxHeight: "80vh",
        display: "flex",
        flexDirection: "column",
        overflow: "hidden"
    },
    modalTitle: {
        margin: "4px 11px",
        fontSize: "22px",
        color:"#04aa6d"
    },
    header: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "10px 15px",
        borderBottom: "1px solid #ddd",
        background: "#f8f8f8",
        flexShrink: 0,// Prevent shrinking
        fontFamily: "poppins",
        marginTop: "12PX"
    },
    closeBtn: {
        background: "transparent",
        border: "none",
        fontSize: "20px",
        cursor: "pointer"
    },
    content: {
        padding: "15px",
        overflowY: "auto",
        flex: 1 // Makes it take remaining height for scrolling
    }
};

export default Modal;
